import { FormattedMessage, useIntl } from 'react-intl';

import { LightningBoltIcon } from '@/components/icons/lightning-bolt';
import { SourceUpgradeCard } from '@/components/ui/source-upgrade-card';

export function UpgradeCard() {
  const intl = useIntl();

  const benefits = [
    intl.formatMessage({
      defaultMessage: "Pause when the funnel's ahead",
      description:
        'Benefit of sourcing automations: sourcing spend stops once the hiring goal is reached',
    }),
    intl.formatMessage({
      defaultMessage: 'Pause at your budget cap',
      description:
        'Benefit of sourcing automations: sourcing spend stops once the hiring goal period end date passes',
    }),
    intl.formatMessage({
      defaultMessage: 'Pause when the goal period closes',
      description:
        'Benefit of sourcing automations: the recruiter does not have to watch spend and pause campaigns by hand',
    }),
  ];

  return (
    <SourceUpgradeCard
      icon={<LightningBoltIcon className="text-fx-primary size-8" />}
      title={
        <FormattedMessage
          defaultMessage="Stop paying for applicants you no longer need"
          description="Headline of the upsell shown to accounts without a Source subscription, on the sourcing automations settings tab"
        />
      }
      description={
        <FormattedMessage
          defaultMessage="Automations are designed to minimize wasted spend by automatically pausing sourcing once hiring goals or budget limits are reached."
          description="Explains what sourcing automations do, in the upsell for accounts without a Source subscription"
        />
      }
      benefits={benefits}
    />
  );
}
